import { Benefits } from '@sunwebgroup/uds-ui/benefits'
import cn from 'classnames'
import * as React from 'react'
import { useCMSPageField } from '@/cms/fields'
import { useCheckoutSid, useCheckoutUsps } from '@/scopes/checkout/domain/hooks'
import styles from './CheckoutBenefits.module.css'

export function CheckoutBenefits() {
  const sid = useCheckoutSid()
  const benefits = useCMSPageField('Checkout.benefits')?.items ?? []

  if (!sid) {
    return null
  }

  return (
    <>
      {benefits?.map(({ componentId }) => {
        return <CheckoutUspsVerticalItem key={componentId} componentId={componentId} />
      })}
    </>
  )
}

function CheckoutUspsVerticalItem(props: { componentId: string }) {
  const { componentId } = props
  const { data, isLoading } = useCheckoutUsps(componentId)

  if (isLoading || !data)
    return ''

  return (
    <Benefits.Root display="list" className={cn(styles.root)}>
      {data?.usps.map((item, idx) => (
        <Benefits.Item key={idx} title={item.text} supportingText={item.subtitle} />
      ))}
    </Benefits.Root>
  )
}
